import { combineReducers } from 'redux';
import { ITEM_TYPES } from '../types';

const getItemTypes = (state = [], action) => {
  switch (action.type) {
    case ITEM_TYPES:
      return [...state, action.payload];
    default:
      return state;
  }
}

export default combineReducers({ getItemTypes });



// WEBPACK FOOTER //
// ./src/reducers/itemReducer.js